import clsx from 'clsx'
import { useRef } from 'react'
import { LocalToastTarget, useLocalToast } from 'react-local-toast'
import { ReactComponent as CopyIcon } from 'assets/icons/copy-link.svg'
import DotsMenu from '../../components/DotsMenu/DotsMenu'

const PortfolioCard = ({
  portfolio,
  onPortfolioClick,
  onPortfolioDoubleClick,
  selectedPortfolios,
  index,
}) => {
  const { showToast } = useLocalToast()
  const clickConsumed = useRef(false)
  const isSelected = selectedPortfolios.find((item) => item.id === portfolio.id)
  const { name } = portfolio
  const toastName = `copy-${portfolio.id}`

  function handlePortfolioMouseDown(evt) {
    clickConsumed.current = false
    if (!isSelected) {
      clickConsumed.current = true
      onPortfolioClick(evt, portfolio)
    }
  }

  function handleMouseUp(evt) {
    if (!clickConsumed.current) {
      onPortfolioClick(evt, portfolio)
    }
  }

  function handlePortfolioDoubleClick() {
    onPortfolioDoubleClick(portfolio)
  }

  async function handleCopyClick(evt) {
    evt.stopPropagation()
    showToast(toastName, 'Copied!', { duration: 1250 })
    const { baseLink } = portfolio
    const link = baseLink + portfolio.slug
    if ('clipboard' in navigator) {
      await navigator.clipboard.writeText(link)
    } else {
      document.execCommand('copy', true, link)
    }
  }

  return (
    <div
      className={clsx(
        'px-4 py-1 flex flex-row transition cursor-pointer',
        'rounded items-center border-0 w-full text-left hover:bg-gray-blue-light',
        {
          'bg-gray-blue ': !isSelected,
          'bg-blue-dark outline outline-1 outline-blue hover:bg-blue':
            isSelected,
          'mt-[1px]': index === 0,
          'mt-2': index !== 0,
        },
      )}
      onMouseDown={handlePortfolioMouseDown}
      onMouseUp={handleMouseUp}
      onDoubleClick={handlePortfolioDoubleClick}
    >
      <div className="flex-1 flex items-center">
        <div className="text-sm whitespace-nowrap flex-1 select-none">
          {name}
        </div>
        <LocalToastTarget name={toastName}>
          <button
            className="flex justify-center items-center  h-[36px] w-[36px] "
            onClick={handleCopyClick}
            data-tooltip="Copy Link"
          >
            <CopyIcon fill="#eee" height="18" />
          </button>
        </LocalToastTarget>
        <DotsMenu containerClass="py-0 w-[30px] ">
          <a
            target="_blank"
            rel="noreferrer"
            href={portfolio.link}
            className="link-button item"
          >
            Visit
          </a>
        </DotsMenu>
      </div>
    </div>
  )
}

export default PortfolioCard
